import { formatNumber } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'bigNumbers',
  standalone: true,
})
export class BigNumbersPipe implements PipeTransform {
  readonly #localId = inject(LOCALE_ID);

  public transform(value: number, digits?: string, useShortSuffix?: boolean, minValue?: number): string {
    if (!minValue) {
      minValue = 1000000;
    }
    if (!digits) {
      digits = '1.0-0';
    }

    let suffix;
    if (value >= 1000000000 && value >= minValue) {
      suffix = useShortSuffix ? 'b' : ' Mrd.';
      return `${formatNumber(value / 1000000000, this.#localId, digits)}${suffix}`;
    }

    if (value >= 1000000 && value >= minValue) {
      suffix = useShortSuffix ? 'm' : ' Mio.';
      return `${formatNumber(value / 1000000, this.#localId, digits)}${suffix}`;
    }

    if (value >= 1000 && value >= minValue) {
      suffix = useShortSuffix ? 'k' : ' Tsd.';
      return `${formatNumber(value / 1000, this.#localId, digits)}${suffix}`;
    }

    return formatNumber(value, this.#localId, digits);
  }
}
